import { flatMap, fromCondition, pipe, tap, tapLeft } from "@otto-ec/assets-core-utils/nano-effect";
import { SHEET_ACTION_USER_AGENT } from "../event/event.activation.js";
import { restoreStack } from "../stack/global.svelte.js";
import { findInstance } from "../stack/stack.utils.js";
import { sheetTagName } from "../utils/consts.js";
import { parseSheetIdOrProps } from "./parameter.js";
import { statePropId, statePropOnLoad, statePropStack, type SheetNavScope } from "./scope.js";
import { navScope } from "./scope.js";
import type { OcSheetV1Props } from "../SheetV1.types.g.js";

const log = /*           */ navScope.scope("page-entry");

/**
 *
 *
 *
 *
 *
 *
 *
 */
export const prepareOpenSheetOnPageEntry = (scope: SheetNavScope): void => {
  if (import.meta.env.DEV) log.info("prepare sheet state for page entry", history.length);

  const hash = scope.hash();
  const state = scope.state();

  /*                                                                                 */
  /*                                                                                    */

  /*                                                                                 */
  /*                                                                                      */
  /*                                                    */

  pipe(
    fromCondition(hash.has(sheetTagName) && state.empty, hash.get(sheetTagName)!, null),
    parseSheetIdOrProps,

    flatMap((sheetIdOrProps) =>
      fromCondition(
        typeof sheetIdOrProps === "object" && !!sheetIdOrProps,
        sheetIdOrProps as OcSheetV1Props,
        null,
      ),
    ),

    tap(() => {
      if (import.meta.env.DEV)
        log.info("ensure empty history entry for page entry", history.length);

      const params = hash.get(sheetTagName)!;
      hash.clear();
      scope.replace();

      /*                                                                       */
      /*                                                      */
      if (import.meta.env.DEV)
        log.info("push new history entry with params", params, history.length);

      /*                                                                               */
      /*              */
      hash.set(sheetTagName, params);
      state.set(statePropOnLoad, true);
      scope.push();
    }),

    tapLeft(() => {
      if (import.meta.env.DEV)
        log.info("no sheet tag in hash or state is not empty, skip page entry handling");
    }),
  );
};

export const restoreFromHistoryState = (scope: SheetNavScope): void => {
  if (import.meta.env.DEV) log.info("restore history stack", history.length);
  const state = scope.state();

  /*                                     */
  if (state.empty) {
    if (import.meta.env.DEV) log.info("no state found, skip restoring stack");
    return;
  }

  /*                                                                                          */
  /*                    */
  if (import.meta.env.DEV)
    log.info("initializing history stack from state", state.get(statePropStack));

  const historyStack = state.get(statePropStack);
  const currentId = state.get(statePropId);

  if (!currentId || !findInstance(currentId)) {
    if (import.meta.env.DEV) log.info("no current sheet instance found, skip restoring stack");
    return;
  }

  restoreStack(currentId, historyStack, SHEET_ACTION_USER_AGENT);
};
